// extracted by mini-css-extract-plugin
export default {"input":"Input_input__LQu1Z","input_placeholder":"Input_input_placeholder__ncaqh","input_text":"Input_input_text__ksFvW","input_clear":"Input_input_clear__TflV-"};